var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.05728 2.22145C0.894969 2.05914 0.894969 1.79598 1.05728 1.63367L1.81515 0.875794C1.97747 0.713482 2.24063 0.713482 2.40294 0.875794L13.2769 11.7498C13.4393 11.9121 13.4393 12.1753 13.2769 12.3376L12.5191 13.0955C12.3568 13.2578 12.0936 13.2578 11.9313 13.0955L1.05728 2.22145Z",
    fill: "url(#paint0_linear_420_107)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9324 0.690093C12.0947 0.527781 12.3579 0.527781 12.5202 0.690093L13.278 1.44797C13.4404 1.61028 13.4404 1.87344 13.278 2.03575L2.40403 12.9098C2.24172 13.0721 1.97856 13.0721 1.81625 12.9098L1.05837 12.1519C0.896061 11.9896 0.896061 11.7264 1.05837 11.5641L11.9324 0.690093Z",
    fill: "url(#paint1_linear_420_107)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_420_107",
    x1: 0.935547,
    y1: 6.89278,
    x2: 13.3998,
    y2: 6.89278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1742FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E2796"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_420_107",
    x1: 0.935547,
    y1: 6.89278,
    x2: 13.3998,
    y2: 6.89278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1742FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E2796"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyClose);
export default __webpack_public_path__ + "static/media/copy_close.19d6744776c27473cadf2480d6ff4aa0.svg";
export { ForwardRef as ReactComponent };